import { Box, Chip, Stack, TextField, Typography } from '@mui/material'
import ButtonCustom from '../../atoms/button/ButtonCustom'
import { ALL_STACKS } from '../../../util/constants'
import InputCustom from '../../atoms/input/InputCustom'
import { toastHelper } from '../../../util/toastHelper'
import styles from '../onboarding.module.scss'

export const VendorBusinessType = ({
	userDetails,
	setUserDetails,
	setStep,
}) => {
	const { businessTypes, customBusinessType } = userDetails

	const handleNext = () => {
		if (businessTypes?.length > 0 || (customBusinessType || '').trim()) {
			setStep((s) => s + 1)
			return
		}
		toastHelper('Please select a business type', 'error')
	}

	const changeType = (stack) => {
		const isSelected = businessTypes?.includes(stack)
		const type = isSelected
			? businessTypes.filter((item) => item !== stack)
			: [...businessTypes, stack]
		setUserDetails({ ...userDetails, businessTypes: type })
	}

	return (
		<div className={styles.form}>
			<Typography variant="h1" gutterBottom>
				Business Type
			</Typography>
			<p style={{ marginBottom: '24px' }}>Select business types</p>
			<Box
				sx={{
					width: '100%',
					mb: 2,
					display: 'flex',
					flexWrap: 'wrap',
					gap: 1,
				}}
			>
				{ALL_STACKS.map((stack) => (
					<Chip
						key={stack}
						label={stack}
						clickable
						sx={{
							bgcolor: businessTypes?.includes(stack)
								? '#7ca6bd'
								: '#FFF',
							color: businessTypes?.includes(stack)
								? '#FFF'
								: '#7ca6bd',
							borderColor: '#DFE4EB',
							borderRadius: '999px',
							transition: 'all 0.15s ease-in-out',
							'&:hover': {
								boxShadow: '0 0 0 1px rgba(124,166,189,0.4)',
							},
						}}
						onClick={() => changeType(stack)}
					/>
				))}
			</Box>

			<InputCustom
				placeholder="Other (Custom Entry)"
				value={customBusinessType}
				setDataFunction={setUserDetails}
				data={userDetails}
				name="customBusinessType"
				onChange={(e) =>
					setUserDetails({
						...userDetails,
						customBusinessType: e.target.value,
					})
				}
			/>

			<div className={styles.skipBtn} style={{ marginTop: '2rem' }}>
				<button
					className="backButton"
					onClick={() => setStep((s) => s - 1)}
				>
					Back
				</button>
				<ButtonCustom onClick={handleNext}>Next</ButtonCustom>
			</div>
		</div>
	)
}
